import { Reveal, Eyebrow } from "@/components/Reveal";
import { CalendarCheck, Video, ShieldCheck } from "lucide-react";
import { BookingPanel } from "@/components/booking/BookingPanel";

const EXPECT = [
  { icon: CalendarCheck, text: "30 minutes, Monday to Friday, 09:00–17:00 UK time" },
  { icon: Video, text: "Video call with a senior AiCendor consultant — never a junior" },
  { icon: ShieldCheck, text: "Confidential by default. No slides, no pitch, no obligation" },
];

export default function Booking() {
  return (
    <section id="book" className="relative py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Book a consultation</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
                Pick a time.
                <br />
                <span className="text-accent">We&rsquo;ll do the rest.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
                Choose a slot that suits you and it lands straight in the AiCendor diary. You&rsquo;ll get an
                instant confirmation, followed by a calendar invitation with the joining link.
              </p>
            </Reveal>
            <div className="mt-12 space-y-5">
              {EXPECT.map(({ icon: Icon, text }, i) => (
                <Reveal key={text} delay={0.25 + i * 0.08}>
                  <div className="flex items-center gap-4 text-sm text-slate-300 sm:text-base">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-white/15">
                      <Icon className="h-4 w-4 text-gold" strokeWidth={1.75} />
                    </span>
                    {text}
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.15} className="lg:col-span-7">
            <BookingPanel />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
